import { createIcon } from "@chakra-ui/icons";

export const RowGroupIcon = createIcon({
  displayName: "RowGroupIcon",
  viewBox: "0 0 16 16",
  defaultProps: {
    width: "16px",
    height: "16px",
  },
  path: (
    <>
      <path
        d="M3.61289 5.4186V12.3866H10.5807V12.6444C10.5807 13.2145 10.1185 13.6767 9.54843 13.6767H3.35489C2.78479 13.6767 2.32263 13.2145 2.32263 12.6444V6.45086C2.32263 5.88076 2.78479 5.4186 3.35489 5.4186H3.61289Z"
        fill="currentColor"
      />
      <path
        d="M6.45154 2.32233H12.6451C13.2152 2.32233 13.6773 2.78449 13.6773 3.35459V9.54813C13.6773 10.1182 13.2152 10.5804 12.6451 10.5804H6.45154C5.88144 10.5804 5.41928 10.1182 5.41928 9.54813V3.35459C5.41928 2.78449 5.88144 2.32233 6.45154 2.32233ZM6.70966 3.61245H12.3871V9.28987H6.70966V3.61245Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
      />
    </>
  ),
});
